import { useState, type CSSProperties } from "react";
import { DcCommerceSection } from "./DcCommerceSection";
import { DcShopOrdersSection } from "./DcShopOrdersSection";
import { DcAudienceSection } from "./DcAudienceSection";
import { DcGraphSection } from "./DcGraphSection";
import { DcActivityLogSection } from "./DcActivityLogSection";
import { DcActivitySection } from "./DcActivitySection";
import { DcPersonalOffersSection } from "./DcPersonalOffersSection";
import { DcCommunitySection } from "./DcCommunitySection";
import { DcClientImpersonationSection } from "./DcClientImpersonationSection";
import { DcVideoStatsSection } from "./DcVideoStatsSection";
import { DcMaterialsStatsSection } from "./DcMaterialsStatsSection";
import { DcVisitsSection } from "./DcVisitsSection";

type Sub = "catalog" | "offers" | "shop" | "audience" | "community" | "impersonate" | "graph" | "log" | "activity" | "visits" | "video" | "paper";

const subNav: CSSProperties = {
  position: "sticky", top: 0, zIndex: 5, display: "flex", flexWrap: "nowrap", gap: 4, overflowX: "auto",
  padding: "3px 8px", background: "var(--surface-1)", borderBottom: "1px solid var(--surface-3)",
};
const tabBtn = (on: boolean): CSSProperties => ({
  flex: "0 1 auto", padding: "3px 6px", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap",
  border: "1px solid " + (on ? "var(--role)" : "var(--surface-3)"),
  background: on ? "var(--role)" : "transparent", color: on ? "#06121a" : "var(--text-2)",
});

export function DcCommerceHub({ onToast, from, to, onSetRange }: { onToast: (m: string) => void; from?: string; to?: string; onSetRange?: (from: string, to: string) => void }) {
  const [sub, setSub] = useState<Sub>("catalog");
  const [leadFilter, setLeadFilter] = useState<{ kind: string; refId: string } | null>(null);
  const openLeads = (offerId: string) => { setLeadFilter({ kind: "offer_lead", refId: offerId }); setSub("log"); };
  return (
    <>
      <nav style={subNav}>
        <button type="button" style={tabBtn(sub === "catalog")} onClick={() => setSub("catalog")}>Каталог</button>
        <button type="button" style={tabBtn(sub === "offers")} onClick={() => setSub("offers")}>Офферы</button>
        <button type="button" style={tabBtn(sub === "shop")} onClick={() => setSub("shop")}>Лавка</button>
        <button type="button" style={tabBtn(sub === "audience")} onClick={() => setSub("audience")}>Аудитория</button>
        <button type="button" style={tabBtn(sub === "community")} onClick={() => setSub("community")}>Коммьюнити</button>
        <button type="button" style={tabBtn(sub === "impersonate")} onClick={() => setSub("impersonate")}>Личина</button>
        <button type="button" style={tabBtn(sub === "graph")} onClick={() => setSub("graph")}>Граф</button>
        <button type="button" style={tabBtn(sub === "log")} onClick={() => setSub("log")}>Лог</button>
        <button type="button" style={tabBtn(sub === "activity")} onClick={() => setSub("activity")}>Активность</button>
        {/* 21.09 (владелец): посещаемость Юнифанса графиками за день или период */}
        <button type="button" style={tabBtn(sub === "visits")} onClick={() => setSub("visits")}>Посещаемость</button>
        <button type="button" style={tabBtn(sub === "video")} onClick={() => setSub("video")}>Видео</button>
        <button type="button" style={tabBtn(sub === "paper")} onClick={() => setSub("paper")}>Газета</button>
      </nav>
      {sub === "catalog" ? <DcCommerceSection onToast={onToast} />
        : sub === "offers" ? <DcPersonalOffersSection onToast={onToast} onOpenLeads={openLeads} />
        : sub === "shop" ? <DcShopOrdersSection onToast={onToast} />
        : sub === "audience" ? <DcAudienceSection onToast={onToast} />
        : sub === "community" ? <DcCommunitySection onToast={onToast} />
        : sub === "impersonate" ? <DcClientImpersonationSection />
        : sub === "graph" ? <DcGraphSection />
        : sub === "log" ? <DcActivityLogSection onToast={onToast} initialKind={leadFilter?.kind} initialRefId={leadFilter?.refId} />
        : sub === "visits" ? <DcVisitsSection from={from} to={to} onSetRange={onSetRange} />
        : sub === "video" ? <DcVideoStatsSection onToast={onToast} from={from} to={to} onSetRange={onSetRange} onImpersonate={() => setSub("impersonate")} />
        : sub === "paper" ? <DcMaterialsStatsSection onToast={onToast} from={from} to={to} onImpersonate={() => setSub("impersonate")} />
        : <DcActivitySection onToast={onToast} from={from} to={to} onSetRange={onSetRange} onImpersonate={() => setSub("impersonate")} onCreateOffer={() => setSub("offers")} />}
    </>
  );
}
